const state = {
    bulkUploadPayoutList: [],
    };
    
    export default state;